import _ from "lodash";
import { RootState } from "src/store";

import { groupsAdapter } from "@dashboard/devices/store/helpers";
import { createSelector } from "@reduxjs/toolkit";

const defaultSelectors = groupsAdapter.getSelectors<RootState>((state) => state.devices.list.groups.items);
export const selectGroups = defaultSelectors.selectAll;
export const selectGroupById = defaultSelectors.selectById;

export const selectGroupsByIds = createSelector(
    defaultSelectors.selectAll,
    (_state: RootState, groupIds: number[]) => groupIds,
    (groups, groupIds) => {
        return groups.filter((group) => groupIds.includes(group.id));
    },
);
export const selectGroupsEntities = defaultSelectors.selectEntities;
export const selectGroupChildrenIds = createSelector(
    defaultSelectors.selectAll,
    (_state: RootState, groupId: number) => groupId,
    (groups, groupId) => {
        const groupedByParent = _.groupBy(groups, "parentId");

        const calculateAggregate = (id: number): number[] => {
            const children = groupedByParent[id] || [];
            return children.map((item) => [item.id, ...calculateAggregate(item.id)]).flat();
        };

        return calculateAggregate(groupId);
    },
);

export default {
    selectGroupById,
    selectGroupsByIds,
    selectGroupsEntities,
    selectGroupChildrenIds,
};
